import React from "react";
import * as styles from "./Header.module.scss";

import { Link, LinkData } from "../Link/Link";

import CasioLogo from "../../assets/svg/casio-logo.svg";
// import ClassPadLogo from "../../assets/svg/classpad-logo.svg";
// import CasioEducationLogo from "../../assets/svg/casio-education-logo-white.svg";
import { Link as GatsbyLink } from "gatsby";
// import { MainNavigation } from "../MainNavigation/MainNavigation";
import { getBasePathForLanguage } from "../../../sanity/plugins/multilanguage";
import { MainNavigationVer2 } from "../MainNavigationVer2/MainNavigationVer2";

export type HeaderData = {
  navigation: LinkData[];
  registerCta: string;
  loginCta: string;
  logoutCta?: string;
};

interface HeaderProps {
  data?: HeaderData;
  language: string;
  availableLanguages?: string[];
}

export const Header: React.FC<HeaderProps> = ({
  data,
  language,
  availableLanguages,
}) => {
  return (
    <header className={styles.header} aria-label="Main Header">
      <GatsbyLink
        className={styles.header__brand}
        to={getBasePathForLanguage(language)}
        aria-label={
          language === "de"
            ? "Casio Education – Zur Startseite gehen"
            : "Les produits et services éducatifs CASIO – page d’accueil"
        } // /* WCAG-Todo */
      >
        <CasioLogo className={styles.header__brand__casio} />
        {/* <ClassPadLogo className={styles.header__brand__classpad} /> */}
        {/* <CasioEducationLogo className={styles.header__brand__classpad} /> */}
      </GatsbyLink>
      {
        <MainNavigationVer2
          language={language}
          registerCta={data?.registerCta}
          loginCta={data?.loginCta}
          logoutCta={data?.logoutCta}
          availableLanguages={availableLanguages}
        >
          {data?.navigation?.map((item, index) => {
            return (
              <li key={index}>
                <Link to={item}></Link>
              </li>
            );
          })}
        </MainNavigationVer2>
      }
    </header>
  );
};
